import get from 'lodash/get';

export const getVerificationError = (state) =>
  get(state, 'auth.emailVerification.verificationError');
export const getCanResend = (state) => state.auth.emailVerification.canResend;
